import { useState } from 'react';
import { Check, Pencil, Trash2, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import SiteFields from './SiteFields';

export const CustomerSiteRow = ({ site, usage, canManage, saving, onSave, onRemove, selected, onSelect }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(site);
  const commit = async (e) => { e.preventDefault(); if (await onSave(draft)) setEditing(false); };
  if (editing) return (
    <li className="py-3" data-testid={`customer-site-edit-form-${site.id}`}>
      <form onSubmit={commit} className="flex items-start gap-2">
        <div className="flex-1 min-w-0"><SiteFields compact value={draft} onChange={setDraft} testPrefix={`customer-site-edit-${site.id}`} /></div>
        <div className="flex flex-col gap-1">
          <Button type="submit" size="sm" className="h-8 px-2 bg-slate-900" disabled={saving} aria-label="Save site" data-testid={`customer-site-edit-save-${site.id}`}><Check size={14} /></Button>
          <Button type="button" size="sm" variant="ghost" className="h-8 px-2" onClick={() => setEditing(false)} aria-label="Cancel site edit" data-testid={`customer-site-edit-cancel-${site.id}`}><X size={14} /></Button>
        </div>
      </form>
    </li>
  );
  return (
    <li className="flex items-start gap-3 py-3 text-sm" data-testid={`customer-site-item-${site.id}`}>
      {canManage && site.lsd && <Checkbox className="mt-1 shrink-0" checked={selected} onCheckedChange={onSelect} aria-label={`Select LSD ${site.lsd}`} data-testid={`customer-site-select-${site.id}`} />}
      <div className="min-w-0 flex-1 grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-x-4 gap-y-1">
        <div className="min-w-0">
          <span className={site.lsd ? 'font-mono break-all text-slate-800' : 'text-slate-400 italic'} data-testid={`customer-site-lsd-${site.id}`}>{site.lsd || (site.address ? 'Address only' : 'Location pending')}</span>
          {site.province && <span className="ml-2 text-xs text-slate-500" data-testid={`customer-site-province-${site.id}`}>{site.province}</span>}
        </div>
        <span className="text-slate-500 text-xs break-words" data-testid={`customer-site-address-${site.id}`}>{site.address || ''}</span>
      </div>
      <div className="flex items-center flex-wrap justify-end gap-2 shrink-0 max-w-24">
        {usage > 0 && <span className="text-xs text-slate-400" data-testid={`customer-site-unit-count-${site.id}`}>{usage} asset{usage === 1 ? '' : 's'}</span>}
        {canManage && <>
          <button type="button" onClick={() => { setDraft(site); setEditing(true); }} className="text-slate-400 hover:text-slate-900" aria-label="Edit site" data-testid={`customer-site-edit-btn-${site.id}`}><Pencil size={14} /></button>
          <button type="button" onClick={onRemove} disabled={saving} className="text-slate-400 hover:text-red-600" aria-label="Remove site" data-testid={`customer-site-remove-btn-${site.id}`}><Trash2 size={14} /></button>
        </>}
      </div>
    </li>
  );
};